<div class="js-{{id}}-selection">
	<select	class="selectpicker" data-style="btn-white" data-title="{{title}}">
		{{#each groups}}
			<optgroup label="{{groupName}}">
				{{#each items}}
					<option value="{{id}}">{{name}}</option>
				{{/each}}
			</optgroup>
		{{/each}}
		{{#each items}}
			<option value="{{id}}">{{name}}</option>
		{{/each}}
	</select>
</div>
